import { Logger } from '@sitecore-search/common';
import { findFacetOnResponse, findFacetValueOnResponseByValueId, findSelectedFacetTextIndex, findSelectedFacetValueIndex, } from '../../utils/index.js';
class RangeFacetClickedReducer {
    process(selectedFacets, response, payload) {
        const { facetId, min, max } = payload;
        const previousValueIndex = selectedFacets.findIndex((item) => item.facetId === facetId);
        const newSelectedFacets = [...selectedFacets];
        const responseFacet = findFacetOnResponse(response, facetId);
        if (previousValueIndex > -1) {
            newSelectedFacets[previousValueIndex] = {
                ...newSelectedFacets[previousValueIndex],
                min,
                max,
                facetLabel: responseFacet ? responseFacet.label : newSelectedFacets[previousValueIndex].facetLabel,
            };
        }
        else {
            newSelectedFacets.push({
                min,
                max,
                facetId,
                facetLabel: responseFacet ? responseFacet.label : '',
            });
        }
        return newSelectedFacets;
    }
}
class ChoiceFacetClickedReducer {
    process(selectedFacets, response, payload) {
        const { facetId, facetValueId, checked } = payload;
        const previousValueIndex = this.findPreviousValueIndex(selectedFacets, facetId, facetValueId, response);
        if (!checked && previousValueIndex > -1) {
            return selectedFacets.filter((_, index) => index !== previousValueIndex);
        }
        const newSelectedFacets = [...selectedFacets];
        const responseFacet = findFacetOnResponse(response, facetId);
        const responseFacetValue = findFacetValueOnResponseByValueId(response, facetId, facetValueId);
        if (checked && previousValueIndex === -1) {
            newSelectedFacets.push(this.buildNewItem(responseFacet, responseFacetValue, facetId, facetValueId));
        }
        return newSelectedFacets;
    }
}
class TextFacetClickedReducer extends ChoiceFacetClickedReducer {
    findPreviousValueIndex(selectedFacets, facetId, facetValueId, response) {
        return findSelectedFacetTextIndex(selectedFacets, facetId, facetValueId, response);
    }
    buildNewItem(responseFacet, responseFacetValue, facetId, facetValueId) {
        return {
            facetId,
            facetValueId,
            facetValueText: responseFacetValue?.text,
            facetLabel: responseFacet ? responseFacet.label : '',
            valueLabel: responseFacetValue ? responseFacetValue.text : '',
        };
    }
}
class ValueIdFacetClickedReducer extends ChoiceFacetClickedReducer {
    buildNewItem(responseFacet, responseFacetValue, facetId, facetValueId) {
        return {
            facetId,
            facetValueId,
            facetLabel: responseFacet ? responseFacet.label : '',
            valueLabel: responseFacetValue ? responseFacetValue.text : '',
        };
    }
    findPreviousValueIndex(selectedFacets, facetId, facetValueId) {
        return findSelectedFacetValueIndex(selectedFacets, facetId, facetValueId);
    }
}
const FacetClickedReducers = {
    range: new RangeFacetClickedReducer(),
    valueId: new ValueIdFacetClickedReducer(),
    text: new TextFacetClickedReducer(),
};
const facetClickedReducer = (state, payload) => {
    const { selectedFacets = [], response } = state;
    const { type } = payload;
    const currentFacetReducer = FacetClickedReducers[type];
    if (currentFacetReducer) {
        return { ...state, page: 1, selectedFacets: currentFacetReducer.process(selectedFacets, response, payload) };
    }
    Logger.warn(`${type} has not a valid action reducer. No reduce transformation applied.`);
    return { ...state, selectedFacets };
};
export default facetClickedReducer;
